module.exports = __webpack_public_path__ + "img/chevron-double-up.b7bbe449.svg";